import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import { EditClientAccountRequest } from 'vopay';
import useDataFetchIndicator from '@/hooks/useDataFetchIndicator';

const hook = vopayApi.withApiHook(({ api }) => {
  return function usePostEditClientAccount() {
    const source = axios.CancelToken.source();
    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const editClientAccount = async (params: EditClientAccountRequest) => {
      try {
        setDataFetchingInfo(true, '', 'fullScreen', false);
        const response = await api.postEditClientAccount(params, source);
        return response;
      } catch (err) {
        console.error(err);
        throw err;
      } finally {
        setDataFetchingInfo(false, '', 'fullScreen', false);
      }
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      editClientAccount,
    };
  };
});

export default hook({});
